import { render, staticRenderFns } from "./template.vue?vue&type=template&id=490069fc&scoped=true&"
import script from "@/Components/Global/LoginForm/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/LoginForm/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/LoginForm/style.scss?vue&type=style&index=0&id=490069fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490069fc",
  null
  
)

export default component.exports